import type { Doc } from "../../_generated/dataModel";
import type { FilterRule, FilterRuleCtx } from "../../lib/types/filters_types";

// Filtra transferencias por estado sin perder el aislamiento por empresa.
export const stockTransferStatusRule: FilterRule<Doc<"stock_transfers">> = {
  priority: 2,
  build: async (ctx: FilterRuleCtx, args) => {
    const status = (
      args as Partial<Doc<"stock_transfers">> & { status?: string }
    ).status;

    if (!status) return undefined;

    return await ctx.db
      .query("stock_transfers")
      .withIndex("by_company_and_status", (q) =>
        q
          .eq("internalControl.companyId", ctx.userContext.companyId)
          .eq("status", status as Doc<"stock_transfers">["status"]),
      )
      .collect();
  },
};
